// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Production extends TrackingModel {
	public ProductionId: number = 0;
	public ProductionStatusId?: number;
	public Name: string = "";
	public Description?: string;
	public AvatarBlobPath?: string;
}